import React from "react";

export const DesktopMenu = () => <h1>DesktopMenu</h1>;
